// extracted by mini-css-extract-plugin
export default {"container":"cp-z","ratingLayout":"dp-z","ratingLabel":"ep-z","nonInteractiveRatingLabel":"fp-z"};